import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from './Subcomponents/Loader';
import MainPage from './Pages/MainPage';
import Login from './Components/Login/Login';
import {
  BrowserRouter as Router,
  useRoutes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import action from './Redux Store/actions';
import { useDispatch, useSelector } from 'react-redux';

//*files
import Lead from './Components/Leads/Leads';
import ChannelPartner from './Components/ChannelPartner/ChannelPartner';
import AllEvents from './Pages/AllEvents/AllEvents';
import FastBooking from './Components/FastBooking/FastBooking';
import QueuePage from './Pages/QueuePage/QueuePage';
import LiveInventory from './Pages/LiveInventory/LiveInventory/LiveInventory';
import AddEvent from './Components/AddEvent/AddEvent';
import ConfigureEvent from './Pages/ConfigureEvent/ConfigureEvent';
import UsersPage from './Pages/Users/UsersPage/UsersPage';
import WorkTransferHub from './Pages/WorkTransfer/WorkTransferHub';
import MoveWorkPage from './Pages/WorkTransfer/MoveWorkPage';
import CpSourcingReassignPage from './Pages/WorkTransfer/CpSourcingReassignPage';
import RearrangeTeamPage from './Pages/WorkTransfer/RearrangeTeamPage';
import CreateUser from './Pages/Users/CreateUser/CreateUser';
import CreateLaunch from './Pages/CreateLaunch/CreateLaunch';
import CreateBasicBrokerageWizard
  from './Pages/BenefitPlan/CreateBasicBrokerageWizard';
import CreatePopWizard from './Pages/BenefitPlan/CreatePopWizard';
import SelectTokens from './Pages/SelectTokens/SelectTokens';
import ProjectMainPage from './Components/Project/ProjectsMainPage/ProjectMainPage.jsx';

//*Sustenance
import Inventory from './Components/Sustenance/Inventory/InventoryMainPage/Inventory';
import InventoryFloors from './Components/Sustenance/Inventory/InventoryFloors/InventoryFloors';
import UnitDetails from './Components/Sustenance/Inventory/UnitDetails/UnitDetails';
import DirectAllotment from './Components/Sustenance//DirectAllotment/DirectPayment/DirectAllotment';
import AllLeads from './Components/Sustenance/SustenanceLeads/AllLeads';
import Sustenance from './Components/Sustenance/SustenanceMainPage/Sustenance';
import Cp from './Components/Sustenance/Cp/Cp.jsx';
import CancelUnitsRequests from './Components/Sustenance/CancelUnitsRequests/CancelUnitsRequests';
import SiteVisit from './Components/Sustenance/SiteVisit/SiteVisit';
import SiteVisitMainPage from './Components/SiteVisit/SiteVisit';
import UnitsChangeRequests from './Components/Sustenance/UnitsChangeRequests/UnitsChangeRequests';

//*Event
import TokenHolders from './Components/Events/TokenHolders/TokenHolders';
import SiteVisits from './Components/Events/EventSiteVisits/EventSiteVisits';
import Queues from './Components/Events/Queues/Queues';
import TokenRefund from './Components/Events/TokenRefundRequests/TokenRefund';
import UnitChanges from './Components/Events/UnitChangeRequests/UnitChanges';
import CancelUnitRequests from './Components/Events/CancelUnitRequests/CancelUnitRequests';
import DirectInventory from './Components/Sustenance/DirectAllotment/DirectInventory/DirectInventory';
import DirectInventoryFloors from './Components/Sustenance/DirectAllotment/DirectInventoryFloors/DirectInventoryFloors';
import EventLaunches from './Components/Events/EventDirectAllotment/EventLaunches/EventLaunches';
import EventProjectFloors from './Components/Events/EventDirectAllotment/EventProjectFloors/EventProjectFloors';
import EventProjectWings from './Components/Events/EventDirectAllotment/EventProjectWings/EventProjectWings';
import EventPayment from './Components/Events/EventDirectAllotment/EventPayments/EventPayment';

import Token from './Components/Token/Token';
import AttendanceConfiguration from './Pages/AttendanceConfiguration/AttendanceConfiguration';
import { useEffect, useRef, useState } from 'react';
import { errorTost, offlineToast, onlineToast } from './Services/Toast';
import Offline from './Pages/OfflinePage/Offline';
import EventSettings from './Pages/EventSettings/EventSettings';
import ProjectDetails from './Components/Project/ProjectsDetails/ProjectDetails';
import AllAllotments from './Components/AllAllotments/AllAllotments';
import FarvisionAllotments from './Components/FarvisionAllotments/FarvisionAllotments';
import AllotmentLetterAdmin from './Pages/AllotmentLetterAdmin/AllotmentLetterAdmin';
import BenefitPlan from './Pages/BenefitPlan/BenefitPlan';
// CRM 2.0 · M12 Template Builder
import Templates from './Pages/Templates/Templates';
import NewTemplate from './Pages/Templates/NewTemplate';
import TemplateVersion from './Pages/Templates/TemplateVersion';
// CRM 2.0 · M12-F4 verify page and VJ Signatory scanner
import VerifyAgreements from './Pages/Crm2Verify/VerifyAgreements';
import AgreementScanner from './Pages/Crm2Verify/AgreementScanner';
import VerifyScan from './Pages/Crm2Verify/VerifyScan';
import GlobalScanner from './Pages/Crm2Verify/GlobalScanner';
import { rememberReturnTo } from './Services/returnTo';
import BasicBrokerageConfig from "./Pages/BenefitPlan/BasicBrokerageConfig";
import CreateBasicBrokeragePlan from "./Pages/BenefitPlan/CreateBasicBrokeragePlan";
import EventQueuePage from './Pages/QueuePage/EventQueuePage.jsx/EventQueuePage';
import Payments from './Pages/Payments/Payments';
import SettingsPage from './Pages/Settings/Settings';
import ShowQrCode from './Subcomponents/ShowQrCode/ShowQrCode';
import LiveInventoryEvents from './Pages/LiveInventory/LiveInventoryEvents';
import MobileSubMenu from './Components/MobileSubMenu/MobileSubMenu';
import EventInventory from './Components/Events/EventInventory/EventInventoryLaunches/EventInventory';
import EventInventoryWings from './Components/Events/EventInventory/EventInventoryWings/EventInventoryWings';
import EventInventoryFloors from './Components/Events/EventInventory/EventInventoryFloors/EventInventoryFloors';
import EventUnitDetails from './Components/Events/EventInventory/EventUnitDetails/EventUnitDetails';
import SustenancePriceList from './Components/Sustenance/SustenancePriceList/SustenancePriceList';
import SustenancePaymentsPlans from './Components/Sustenance/SustenancePaymentPlans/SustenancePaymentsPlans';
import SustenanceSales from './Components/Sustenance/SustenanceSales/SustenanceSales';
import Dashboard from './Components/Dashboard/Dashboard';
import TokenCard from './Pages/TokenCard';
import EventSales from './Components/Events/EventSales/EventSales';
import EventCp from './Components/Events/EventCp/EventCp';
import { supabase } from './supabaseClient';
import ForgetPassword from './Components/ForgetPassword/ForgetPassword';
import axios from 'axios';
import ResetPassword from './Components/ResetPassword/ResetPassword';
import BookingWelcomePdf from './Components/BookingWelcomePdf/BookingWelcomePdf';
import EventsDashboard from './Components/Dashboard/EventsDashboard/EventsDashboard';
import EventsDashboardNew from './Components/Dashboard/EventsDashboard/EventsDashboardNew';
import { Box } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from "react-query-devtools";
import { ReactQueryDevtools } from "react-query/devtools";
import Profile from "./Pages/Profile/Profile";
import Hierarchys from "./Pages/Hierarchy/Hierarchy";
import BulkTokenRefund from "./Components/Events/BulkTokenRefund/BulkTokenRefund";
import DigitalCostSheetViewer from './Components/DigitalCostSheetViewer/DigitalCostSheetViewer';
import BankDetailForm from './Components/BankDetailForm/BankDetailForm';
import CancellationBankDetails from './Pages/CancellationBankDetails/CancellationBankDetails';
import Collaterals from './Components/Sustenance/Collaterals/Collaterals';
import DailyReports from './Components/Dashboard/DailyReports'
import LogoutPopup from './Modals/TokenExpireModal/logoutPopup';
import AllotmentSoldDetails from './Components/Dashboard/AllotmentSoldDetails/AllotmentSoldDetails.jsx';

import SalesDashboard from './Components/SalesDashboard/SalesDashboard.jsx';
import SalesDashboardNew from './Components/SalesDashboard/SalesDashboardNew.jsx';
import CancellationsAndRefunds from "./Components/Dashboard/CancellationsAndRefunds/CancellationsAndRefunds.jsx";
import PaymentStatus from "./Components/Dashboard/PaymentStatus/PaymentStatus.jsx";
import TokenPaymentStatus from "./Components/Dashboard/PaymentStatus/TokenPaymentStatus/TokenPaymentStatus.jsx";
import InventoryDetails from "./Components/Dashboard/InventoryDetails/InventoryDetails.jsx";
import IndividualAllotmentDetails from "./Components/Dashboard/IndividualAllotmentDetails/IndividualAllotmentDetails";
import HoldPageDetails from "./Components/Project/HoldPage/HoldPageDetails"
import ProjectOperatingPlan from './Pages/BenefitPlan/ProjectOperatingPlan.jsx';

import AOPConfigurations from './Pages/BenefitPlan/AOPConfigurations.jsx';
import AOPForm from './Pages/BenefitPlan/AOPForm.jsx';
import CreateAopWizard from './Pages/BenefitPlan/CreateAopWizard.jsx';
import CpPayout from './Components/CPPayout/CpPayout.jsx';

import SmartFlo from './Components/SmartFlo/Smartflo';
import CallLogs from './Components/CallLogs/CallLogsMain.jsx';
import CpSourcingMain from './Components/CpSourcing/CpSourcingMain';
import SalesManagerPersona from './Components/SalesManagerPersona/SalesManagerPersona';
import CrmHelpDesk from './Components/HelpDesk/CrmHelpDesk';
import Crm2Page from './Pages/Crm2/Crm2Page';
import Crm2NotificationsPage from './Pages/Crm2/Crm2NotificationsPage';
import { canOpenCrm2 } from './Components/Crm2/ui/access';
import BankingPage from './Pages/Banking/BankingPage';
import RiderApp from './Pages/Rider/RiderApp';

// CRM2: permission keys that have no page of their own yet (Documents is M12).
// After login a role must not land on them (blank page); take the next key.
// Remove a key here when its page exists (Banking: M10-F1). "CRM 2.0" has a page
// (M1-F9) but only for roles with CRM 2.0 › Tabs and sub-tabs (canOpenCrm2).
const CRM2_NO_PAGE_YET = ['Documents'];
function landingTab(tabAccess, crm2PageOk) {
  const tab = tabAccess.find((t) => !CRM2_NO_PAGE_YET.includes(t) && (t !== 'CRM 2.0' || crm2PageOk));
  if (!tab) console.warn('[crm2][App] role has only CRM 2.0 keys without a page yet', { tabAccess });
  else if (tab !== tabAccess[0]) console.log('[crm2][App] landing skips keys without a page yet', { skipped: tabAccess[0], landing: tab });
  return tab || tabAccess[0];
}

function App() {
  useEffect(() => {
    window.addEventListener('online', function (e) {
      this.document
        .getElementById('root')
        .setAttribute('pointer-events', 'unset');
      onlineToast();
      window.location.reload();
    });
    window.addEventListener('offline', function (e) {
      offlineToast();
      this.document
        .getElementById('root')
        .setAttribute('pointer-events', 'none');
    });
  }, []);
  const dispatch = useDispatch();
  dispatch(action.authCheck());
  const [isOnline, setIsOnline] = useState(true);
  const isAuthenticatedUseRef = useRef(false);
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);

  const [showModal, setShowModal] = useState(false);

  const session_ = supabase.auth.session();
  function logoutUser() {
    setShowModal(true);
  }

  useEffect(() => {
    isAuthenticatedUseRef.current = isAuthenticated;
  }, [isAuthenticated])

  useEffect(() => {
    let flag = false;
    supabase.auth.onAuthStateChange((event, session) => {
      if ((event === "TOKEN_REFRESHED" || event === "SIGNED_OUT") && !flag && !showModal && isAuthenticatedUseRef.current) {
        logoutUser();
        //todo Logout Logic
        flag = true;
      } else {
        flag = false;
      }
    })
  }, [])

  // not logged in on a verify / scanner page: remember it, then the login brings the user back (DC-222)
  const LoginFirst = () => {
    const location = useLocation();
    rememberReturnTo(location.pathname);
    return <Navigate to='/login' />;
  };

  const AppWrapper = () => {
    let tabAccess = [];
    let SubTabAccess = [];
    let SubEventAccess = [];
    let SubEventViewAccess = [];
    let WorkTransferMoveWorkViewAccess = false;
    let WorkTransferMoveWorkExecuteAccess = false;
    let WorkTransferCpSourcingManagerViewAccess = false;
    let WorkTransferCpSourcingManagerExecuteAccess = false;
    let WorkTransferRearrangeTeamViewAccess = false;
    let WorkTransferRearrangeTeamExecuteAccess = false;
    let showErrorTost = true;
    const loggedInUser = useSelector((state) => state?.Auth?.user);
    if (isAuthenticated) {
      if (loggedInUser?.roleId !== null) {
        if (
          loggedInUser?.roleId?.accessibleTabs === undefined ||
          loggedInUser?.roleId?.accessibleTabs === null
        ) {
          localStorage.clear();
          sessionStorage.clear();
          // CRM2 M1.7: a role saved without tabs has accessibleTabs null; Object.keys(null) crashed the app here
          console.warn("[crm2][App] role has no accessibleTabs, treating as no access", { roleId: loggedInUser?.roleId?.roleId });
          tabAccess = Object.keys(loggedInUser?.roleId?.accessibleTabs || {});
          console.log({ tabAccess });
          SubTabAccess =
            loggedInUser?.roleId?.accessibleTabs?.Sustenance?.isAccessible;
          console.log(SubTabAccess);
          SubEventAccess =
            loggedInUser?.roleId?.accessibleTabs?.Event?.isAccessible;
          SubEventViewAccess = loggedInUser?.roleId?.accessibleTabs?.Event
            ? loggedInUser?.roleId?.accessibleTabs?.Event['View Details']
              ?.isAccessible
            : false;
          WorkTransferMoveWorkViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork?.View
              ?.isAccessible;
          WorkTransferMoveWorkExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.Execute?.isAccessible;
          WorkTransferCpSourcingManagerViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.View?.isAccessible;
          WorkTransferCpSourcingManagerExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.Execute?.isAccessible;
          WorkTransferRearrangeTeamViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.View?.isAccessible;
          WorkTransferRearrangeTeamExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.Execute?.isAccessible;
          console.log('SubEventAccess-', SubEventAccess);
          console.log('SubEventViewAccess-', SubEventViewAccess);
        } else {
          tabAccess = Object.keys(loggedInUser?.roleId?.accessibleTabs);
          console.log({ tabAccess });
          SubTabAccess =
            loggedInUser?.roleId?.accessibleTabs?.Sustenance?.isAccessible;
          console.log(SubTabAccess);
          SubEventAccess =
            loggedInUser?.roleId?.accessibleTabs?.Event?.isAccessible;
          SubEventViewAccess = loggedInUser?.roleId?.accessibleTabs?.Event
            ? loggedInUser?.roleId?.accessibleTabs?.Event['View Details']
              ?.isAccessible
            : false;
          WorkTransferMoveWorkViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork?.View
              ?.isAccessible;
          WorkTransferMoveWorkExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer?.MoveWork
              ?.Execute?.isAccessible;
          WorkTransferCpSourcingManagerViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.View?.isAccessible;
          WorkTransferCpSourcingManagerExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.CpSourcingManager?.Execute?.isAccessible;
          WorkTransferRearrangeTeamViewAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.View?.isAccessible;
          WorkTransferRearrangeTeamExecuteAccess =
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.WorkTransfer
              ?.RearrangeTeam?.Execute?.isAccessible;
          console.log('SubEventAccess', SubEventAccess);
          console.log('SubEventViewAccess-', SubEventViewAccess);
        }
      } else {
        localStorage.clear();
        sessionStorage.clear();
        if (showErrorTost) {
          showErrorTost = false;
          console.log({ loggedInUser });
          errorTost('Please check if this user has been assign to any role.');
        }
      }
    }

    let location = useLocation();
    useEffect(() => {
      console.log(window.navigator.onLine);
      if (window.navigator.onLine) {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }, [location.pathname]);
    // CRM 2.0 › Verify agreements, shown as "Agreement Sign" (DC-222): level 1, or the role has CRM 2.0 › Verify agreements switched on
    const tabs = loggedInUser?.roleId?.accessibleTabs;
    const canVerify = loggedInUser?.roleId?.level == 1
      || !!(tabs?.['CRM 2.0']?.isAccessible && tabs?.['CRM 2.0']?.['Verify agreements']?.isAccessible);
    let routes = useRoutes([
      { path: '/cancellation_bank_details', element: <BankDetailForm /> },
      // a QR link opened before login: login first, then back to the same page
      {
        path: '/crm2',
        element: isAuthenticated && loggedInUser?.roleId ? <MainPage /> : <LoginFirst />,
        children: [
          { path: '/crm2/verify-agreements', element: canVerify ? <VerifyAgreements /> : <Navigate to='/home' /> },
          // Scan any QR (a fixed path, so it is not read as an agreement id)
          { path: '/crm2/verify-agreements/scan', element: canVerify ? <GlobalScanner /> : <Navigate to='/home' /> },
          { path: '/crm2/verify-agreements/:copyId', element: canVerify ? <AgreementScanner /> : <Navigate to='/home' /> },
        ],
      },
      // one QR scanned with the normal phone camera: any logged-in user (values masked unless the role may see them)
      { path: '/verify/:first/:second', element: isAuthenticated && loggedInUser?.roleId ? <VerifyScan /> : <LoginFirst /> },
      { path: '/', element: <Navigate to={'/login'} /> },
      { path: '/login', element: <Login /> },
      { path: '/ForgetPassword', element: <ForgetPassword /> },
      { path: "/Digital-Cost-Sheet/:projectId", element: <DigitalCostSheetViewer /> },
      // M15-F3 VJ Rider: own sign-in (Rider pool mobile + OTP), no Sales App login
      { path: '/rider', element: <RiderApp /> },
      { path: '/rider/:slotBookingId', element: <RiderApp /> },
      { path: '/ResetPassword', element: <ResetPassword /> },
      {
        path: '/home',
        element: isAuthenticated ? (
          loggedInUser.roleId ? (
            <MainPage />
          ) : (
            <Navigate to='/' />
          )
        ) : (
          <Navigate to='/' />
        ),
        children: [
          {
            path: '',
            element: isAuthenticated ?
              loggedInUser.roleId ?
                tabAccess.includes('Leads') ? <Lead /> :
                  tabAccess.includes("API Reports") ? <Navigate to='/home/APIDailyReports' /> :
                    // a VJ Signatory whose first permission is CRM 2.0 › Verify agreements (and who cannot open the CRM 2.0
                    // page) lands on Agreement Sign; every other role lands as landingTab picks (M1-F9)
                    tabAccess[0] === 'CRM 2.0' && canVerify && !canOpenCrm2(loggedInUser) ? <Navigate to='/crm2/verify-agreements' /> :
                    <Navigate to={landingTab(tabAccess, canOpenCrm2(loggedInUser)) === 'CRM 2.0' ? '/home/Crm2' : `/home/${landingTab(tabAccess, canOpenCrm2(loggedInUser)).replaceAll(' ', '')}`} />
                : <Navigate to='/' />
              : <Navigate to='/' />

          },
          {
            path: '/home/Leads',
            element: isOnline ? (
              tabAccess.includes('Leads') ? (
                <Lead />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Profile',
            element: isOnline ? <Profile /> : <Offline />,
          },
          {
            path: '/home/Dashboard',
            element: isOnline ? (
              tabAccess.includes('Dashboard') ? (
                <SalesDashboard />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          {
            // New standalone tab — separate from the old '/home/Dashboard'
            // above, gated by its own 'Sales Dashboard' accessibleTabs key.
            path: '/home/SalesDashboard',
            element: isOnline ? (
              tabAccess.includes('Sales Dashboard') ? (
                <SalesDashboardNew />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Dashboard/Allotment',
            element: isOnline ? (
              tabAccess.includes('Dashboard') ? (
                (loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? <AllotmentSoldDetails /> : <IndividualAllotmentDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Dashboard/Inventory',
            element: isOnline ? (
              tabAccess.includes('Dashboard') ? (
                <InventoryDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: "/home/Dashboard/CancellationsAndRefunds",
            element: isOnline ? (
              tabAccess.includes("Dashboard") ? (
                <CancellationsAndRefunds />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "/home/Dashboard/PaymentStatus",
            element: isOnline ? (
              tabAccess.includes("Dashboard") ? (
                <PaymentStatus />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "/home/Dashboard/TokenPaymentStatus",
            element: isOnline ? (
              tabAccess.includes("Dashboard") ? (
                <TokenPaymentStatus />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "/home/Event",
            element: isOnline ? (
              tabAccess.includes("Event") ? (
                <AllEvents />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Sustenance',
            element: isOnline ? (
              tabAccess.includes('Sustenance') ? (
                <Sustenance />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/SiteVisit',
            element: isOnline ? (
              tabAccess.includes('Site Visit') ? (
                <SiteVisitMainPage />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/FastBooking',
            element: isOnline ? (
              tabAccess.includes('FastBooking') ? (
                <FastBooking />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/ChannelPartner',
            element: isOnline ? (
              tabAccess.includes('Partners') ? (
                <ChannelPartner />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId',
            element: <ConfigureEvent />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/CreateLaunch/',
            element: <CreateLaunch />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/attendanceConfiguration/',
            element: <AttendanceConfiguration />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/SelectTokens/',
            element: <SelectTokens />,
          },
          { path: '/home/Queue', element: <QueuePage /> },
          { path: '/home/Queue/:eventId', element: <EventQueuePage /> },
          { path: '/home/Queue/:eventId/:launchId', element: <EventQueuePage /> },
          { path: '/home/Event/AddEvent', element: <AddEvent /> },

          {
            path: '/home/Event/ConfigureEvent/:eventId',
            element: <ConfigureEvent />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/Settings/',
            element: <EventSettings />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/CreateLaunch/',
            element: <CreateLaunch />,
          },
          {
            path: '/home/Event/ConfigureEvent/:eventId/SelectTokens/',
            element: <SelectTokens />,
          },

          {
            path: '/home/Queue',
            element: isOnline ? (
              tabAccess.includes('Queue') ? (
                <QueuePage />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          { path: '/home/Event/AddEvent', element: <AddEvent /> },

          //*Sustenance-subMenu--->
          //inventory
          {
            path: '/home/Sustenance/Details/:projectId/Inventory',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <Inventory />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Sustenance/Details/:projectId/Inventory/:wingName',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <InventoryFloors />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Sustenance/Details/:projectId/Inventory/:wingName/:unitNo',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <UnitDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //cp-sales
          {
            path: '/home/Sustenance/Details/:projectId/Cp',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <Cp />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: '/home/Sustenance/Details/:projectId/Sales',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <SustenanceSales />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //All-Leads
          {
            path: '/home/Sustenance/Details/:projectId/Lead',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <AllLeads />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //SiteVisit
          {
            path: '/home/Sustenance/Details/:projectId/SiteVisit',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <SiteVisit />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //Direct-Allotment-Sustenance
          {
            path: '/home/Sustenance/Details/:projectId/DirectAllotment',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <DirectInventory />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Sustenance/Details/:projectId/DirectAllotment/:wingName',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <DirectInventoryFloors />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Sustenance/Details/:projectId/DirectAllotment/:wingName/:unitNo',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <DirectAllotment />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //Price-List-sus
          {
            path: '/home/Sustenance/Details/:projectId/PriceList',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <SustenancePriceList />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //Payment-Plans-sus
          {
            path: '/home/Sustenance/Details/:projectId/PaymentPlans',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <SustenancePaymentsPlans />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //Cancel-unit-sus
          {
            path: '/home/Sustenance/Details/:projectId/CancelUnitsRequests',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <CancelUnitsRequests />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //change-unit-sus
          {
            path: '/home/Sustenance/Details/:projectId/UnitChangeRequests',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <UnitsChangeRequests />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //Collaterals
          {
            path: '/home/Sustenance/Details/:projectId/Collaterals',
            element: isOnline ? (
              tabAccess.includes('Sustenance') && SubTabAccess === true ? (
                <Collaterals />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //*Events-subMenu
          //Inventory-Events
          {
            path: '/home/Event/Details/:eventID/Inventory',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventInventory />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/Inventory/:launchId/:projectId',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventInventoryWings />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/Inventory/:launchId/:projectId/:wingName',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventInventoryFloors />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/Inventory/:launchId/:projectId/:wingName/:unitNo',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventUnitDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //Cp-sales-events
          {
            path: '/home/Event/Details/:eventID/Cp',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventCp />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: '/home/Event/Details/:eventID/Sales',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventSales />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //token-holders-events
          {
            path: '/home/Event/Details/:eventID/TokenHolders',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <TokenHolders />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //Site-visit-events
          {
            path: '/home/Event/Details/:eventID/SiteVisit',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <SiteVisits />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          //direct-Allotment-events
          {
            path: '/home/Event/Details/:eventID/DirectAllotment',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventLaunches />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/DirectAllotment/:launchId/:projectId',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventProjectWings />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/DirectAllotment/:launchId/:projectId/:wingName',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventProjectFloors />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Event/Details/:eventID/DirectAllotment/:launchId/:projectId/:wingName/:unitNo',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <EventPayment />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //Token-refund-events
          {
            path: '/home/Event/Details/:eventID/TokenRefundRequests',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <TokenRefund />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          // Bulk Refund without request
          {
            path: "/home/Event/Details/:eventID/BulkTokenRefund",
            element: isOnline ? (
              tabAccess.includes("Event") &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <BulkTokenRefund />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          // Bulk Refund without request
          {
            path: "/home/Event/Details/:eventID/BulkTokenRefund",
            element: isOnline ? (
              tabAccess.includes("Event") &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <BulkTokenRefund />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },
          //Cancel-unit-events
          {
            path: '/home/Event/Details/:eventID/CancelUnitRequests',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <CancelUnitRequests />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //Queue
          {
            path: '/home/Event/Details/:eventID/Queue',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <Queues />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          //unit-Change-events
          {
            path: '/home/Event/Details/:eventID/UnitChangeRequests',
            element: isOnline ? (
              tabAccess.includes('Event') &&
                SubEventAccess === true &&
                SubEventViewAccess === true ? (
                <UnitChanges />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: '/home/TokenCard',
            element: <TokenCard />,
          },

          {
            path: '/home/users',
            element: isOnline ? (
              tabAccess.includes('Users') ? (
                <UsersPage />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          // Work Transfer module — gated on the SAME accessibleTabs mechanism as
          // every other route here, now down to the MoveWork/History
          // sub-permission level (View gates visibility, Execute gates
          // whether the page's Review/confirm step is usable — see
          // MoveWorkPage's canExecute prop).
          {
            path: '/home/WorkTransfer',
            element: isOnline ? (
              tabAccess.includes('WorkTransfer') ? <WorkTransferHub /> : <Navigate to='/' />
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/WorkTransfer/MoveWork',
            element: isOnline ? (
              tabAccess.includes('WorkTransfer') && WorkTransferMoveWorkViewAccess ? (
                <MoveWorkPage canExecute={WorkTransferMoveWorkExecuteAccess} />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/WorkTransfer/CpSourcingManager',
            element: isOnline ? (
              tabAccess.includes('WorkTransfer') && WorkTransferCpSourcingManagerViewAccess ? (
                <CpSourcingReassignPage canExecute={WorkTransferCpSourcingManagerExecuteAccess} />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/WorkTransfer/RearrangeTeam',
            element: isOnline ? (
              tabAccess.includes('WorkTransfer') && WorkTransferRearrangeTeamViewAccess ? (
                <RearrangeTeamPage canExecute={WorkTransferRearrangeTeamExecuteAccess} />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Hierarchy',
            element: isOnline ? (
              tabAccess.includes('Hierarchy') ? (
                <Hierarchys />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/cancellation_bank_details_approval',
            element: isOnline ? (
              tabAccess.includes('Cancellation Bank Details') ? (
                <CancellationBankDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          { path: '/home/users/createUser', element: <CreateUser /> },
          {
            path: '/home/Projects',
            element: isOnline ? (
              tabAccess.includes('Project') ? (
                <ProjectMainPage />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: '/home/Hold',
            element: isOnline ? (
              tabAccess.includes('Hold/Release') ? (
                <HoldPageDetails />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
           {
            path: '/home/SmartFlo',
            element: isOnline ? (
              tabAccess.includes('SmartFlo') ? (
                <SmartFlo />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
           {
            path: '/home/callLogs',
            element: isOnline ? (
              tabAccess.includes('CallLogs') ? (
                <CallLogs/>
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/cpSourcing',
            element: isOnline ? (
              tabAccess.includes('CpSourcing') ? (
                <CpSourcingMain />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/salesManagerPersona',
            element: isOnline ? (
              tabAccess.includes('Sales Manager Persona') ? (
                <SalesManagerPersona />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/CRM-helpdesk',
            element: isOnline ? <CrmHelpDesk /> : <Offline />,
          },
          {
            path: '/home/Projects/:projectId',
            element: isOnline ? <ProjectDetails /> : <Offline />,
          },
          {
            path: '/home/Token',
            element: isOnline ? (
              tabAccess.includes('Token') ? (
                <Token />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/AllAllotments',
            element: isOnline ? (
              tabAccess.includes('All Allotments') ? (
                <AllAllotments />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            // CRM2 M1.4b: CRM 2.0 page (needs CRM 2.0 › Tabs and sub-tabs, or Super Admin)
            path: '/home/Crm2',
            element: isOnline ? (
              tabAccess.includes('CRM 2.0') && canOpenCrm2(loggedInUser) ? <Crm2Page /> : <Navigate to='/' />
            ) : (
              <Offline />
            ),
          },
          {
            // CRM2 M1-F8: "See all" of the CRM 2.0 bell; any logged-in user (the server returns only their own rows)
            path: '/home/Crm2Notifications',
            element: isOnline ? <Crm2NotificationsPage /> : <Offline />,
          },
          {
            // CRM2 M10-F1: Banking page (CF NOC, Lenders); needs the "Banking" key
            path: '/home/Banking',
            element: isOnline ? (
              tabAccess.includes('Banking') ? <BankingPage /> : <Navigate to='/' />
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/FarvisionAllotments',
            element: isOnline ? <FarvisionAllotments /> : <Offline />,
          },
          {
            path: '/home/BenefitPlan',
            element: isOnline ? (
              tabAccess.includes('Benefit Plan') ? (
                <BenefitPlan key={location.state?.timestamp || "initial"} />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Templates',
            element: isOnline ? (
              tabAccess.includes('Templates') ? (
                <Templates />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Templates/new',
            element: isOnline ? (
              tabAccess.includes('Templates') ? (
                <NewTemplate />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Templates/:id',
            element: isOnline ? (
              tabAccess.includes('Templates') ? (
                <TemplateVersion />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/CPPayout',
            element: isOnline ? (
              tabAccess.includes('CpPayout') ? (
                <CpPayout />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
       
          {
            path: '/home/BenefitPlan/basic-brokerage',
            element: isOnline ? (
              tabAccess.includes('Benefit Plan') ? (
                <BasicBrokerageConfig />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/BenefitPlan/basic-brokerage/create',
            element: isOnline ? (
              tabAccess.includes('Benefit Plan') ? (
                <CreateBasicBrokerageWizard />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/BenefitPlan/pop',
            element: isOnline ? (
              tabAccess.includes('Benefit Plan') ? (
                <ProjectOperatingPlan key={location.state?.timestamp || "initial"} />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "/home/BenefitPlan/pop/popForm",
            element: isOnline ? (
              tabAccess.includes("Benefit Plan") ? (
                <CreatePopWizard />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },




          {
            path: '/home/BenefitPlan/aop',
            element: isOnline ? (
              tabAccess.includes('Benefit Plan') ? (
                <AOPConfigurations />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: "/home/BenefitPlan/aop/aopForm",
            element: isOnline ? (
              tabAccess.includes("Benefit Plan") ? (
                <CreateAopWizard />
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Offline />
            ),
          },


          {
            path: '/home/Payments',
            element: isOnline ? (
              tabAccess.includes('Payments') ? (
                <Payments />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: '/home/Settings',
            element: isOnline ? (
              tabAccess.includes('Settings') ? (
                <SettingsPage />
              ) : (
                <Navigate to='/' />
              )
            ) : (
              <Offline />
            ),
          },

          {
            path: '/home/LiveInventory',
            element: isOnline ? <LiveInventoryEvents /> : <Offline />,
          },
          {
            path: '/home/ShowQrCode',
            element: isOnline ? <ShowQrCode /> : <Offline />,
          },
          {
            path: '/home/MobileSubMenu',
            element: isOnline ? <MobileSubMenu /> : <Offline />,
          },
          {
            path: '/home/APIDailyReports',
            element: <DailyReports />,
          },
          {
            path: '/home/APIDailyReports/:tab/:subTab',
            element: <DailyReports />,
          },
          {
            path: '/home/APIDailyReports/:tab/:subTab/:type',
            element: <DailyReports />,
          },
          {
            path: '/home/AllotmentLetterAdmin',
            element: isOnline ? <AllotmentLetterAdmin /> : <Offline />,
          },
          {
            path: '/home/Profile',
            element: isOnline ? <Profile /> : <Offline />,
          }
        ],
      },
      { path: '/BookingWelcomePdf', element: <BookingWelcomePdf /> },
      {
        path: '/BookingMIS/:eventName/:launchName',
        element: (
          <Box padding={'2rem'}>
            <EventsDashboard />
            {/* <EventsDashboardNew /> */}
          </Box>
        ),
      },
      {
        path: '/BookingMISNEW/:eventName/:launchName',
        element: (
          <Box padding={'2rem'}>
            {/* <EventsDashboard /> */}
            <EventsDashboardNew />
          </Box>
        ),
      },
      {
        path: '/APIDailyReports',
        element: (
          <DailyReports />
        ),
      },
      {
        path: '/APIDailyReports/:tab/:subTab',
        element: (
          <DailyReports />
        ),
      },
      {
        path: '/APIDailyReports/:tab/:subTab/:type',
        element: (
          <DailyReports />
        ),
      },
      {
        path: '/home/liveInventory/:eventId/:launchId/:wingId/:projectId',
        element: isOnline ? <LiveInventory /> : <Offline />,
      },
      {
        path: '/home/liveInventory/:wingId/:projectId',
        element: isOnline ? <LiveInventory /> : <Offline />,
      },
    ]);
    return routes;
  };

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider queryClient={queryClient} client={queryClient}>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <div style={{ height: '100%' }}>
        {/* <Router> */}
        <AppWrapper />
        {/* </Router> */}
        <ToastContainer style={{ fontSize: '1.5rem' }} />
        <Loading />
      </div>
      {showModal && (
        <>
          <LogoutPopup
            open={showModal}
            handleClose={() => {
              setShowModal(false);
            }}
          />
        </>
      )}
    </QueryClientProvider>
  );
}
export default App;
